import type { ReactNode } from "react";

// Piezas compartidas del centro de Ayuda. Cada Section lleva `id` para que
// el índice de Ayuda.tsx y los links externos puedan anclar (#casos, etc.).

export function Section({
  id,
  title,
  children,
}: {
  id?: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className="scroll-mt-20">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-zinc-400 mb-2">
        {title}
      </h2>
      <div className="card text-sm text-zinc-200 space-y-1">{children}</div>
    </section>
  );
}

export function Captura({
  src,
  alt,
  caption,
}: {
  src: string;
  alt: string;
  caption?: string;
}) {
  return (
    <figure className="my-3">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="rounded-lg border border-ink-700 w-full"
      />
      {caption && (
        <figcaption className="text-xs text-zinc-500 mt-1">{caption}</figcaption>
      )}
    </figure>
  );
}

export function Pill({ tone, children }: { tone: string; children: ReactNode }) {
  const cls: Record<string, string> = {
    amber: "bg-amber-500/10 text-amber-300 border-amber-500/30",
    cyan: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
    violet: "bg-violet-500/10 text-violet-300 border-violet-500/30",
    sky: "bg-sky-500/10 text-sky-300 border-sky-500/30",
    emerald: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
    red: "bg-red-500/10 text-red-300 border-red-500/30",
  };
  return (
    <span className={`inline-block mr-2 mb-1 rounded border px-2 py-0.5 text-xs ${cls[tone]}`}>
      {children}
    </span>
  );
}

export function Dot({ color }: { color: string }) {
  const cls: Record<string, string> = {
    emerald: "bg-emerald-400",
    amber: "bg-amber-400",
    red: "bg-red-400",
    sky: "bg-sky-400",
    orange: "bg-orange-400",
  };
  return <span className={`inline-block h-2 w-2 rounded-full mr-2 ${cls[color]}`} />;
}
